import Vue from 'vue'
import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false } })

import VueAnimate from 'vue-animate-scroll'


var SocialSharing = require('vue-social-sharing')
Vue.use(SocialSharing)

Vue.use(VueAnimate)
window.Vue = Vue



// WEBPACK FOOTER //
// ./src/js/vendor.js